var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"icon-btn"},_vm.$listeners),[_c('p-icon',{attrs:{"icon-name":_vm.iconName,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }